import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJurisdictionCodeBooksQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetJurisdictionCodeBooksQuery = { __typename?: 'query_root', jurisdiction_adopted_codes: Array<{ __typename?: 'jurisdiction_adopted_codes', code_book_id: any, discipline?: string | null, adopted_on?: any | null, code_book: { __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null, title: string, book_type: string, source_file_url?: string | null, source_file_name?: string | null, section_count: number } }> };


export const GetJurisdictionCodeBooksDocument = gql`
    query getJurisdictionCodeBooks($jurisdictionId: uuid!) {
  jurisdiction_adopted_codes(
    where: {jurisdiction_id: {_eq: $jurisdictionId}, code_book: {active: {_eq: true}}}
    order_by: [{sort_order: asc}, {code_book: {book_type: desc}}, {code_book: {abbreviation: asc}}]
  ) {
    code_book_id
    discipline
    adopted_on
    code_book {
      id
      abbreviation
      edition_year
      title
      book_type
      source_file_url
      source_file_name
      section_count
    }
  }
}
    `;

/**
 * __useGetJurisdictionCodeBooksQuery__
 *
 * To run a query within a React component, call `useGetJurisdictionCodeBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJurisdictionCodeBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJurisdictionCodeBooksQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetJurisdictionCodeBooksQuery(baseOptions: Apollo.QueryHookOptions<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables> & ({ variables: GetJurisdictionCodeBooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables>(GetJurisdictionCodeBooksDocument, options);
      }
export function useGetJurisdictionCodeBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables>(GetJurisdictionCodeBooksDocument, options);
        }
export function useGetJurisdictionCodeBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables>(GetJurisdictionCodeBooksDocument, options);
        }
export type GetJurisdictionCodeBooksQueryHookResult = ReturnType<typeof useGetJurisdictionCodeBooksQuery>;
export type GetJurisdictionCodeBooksLazyQueryHookResult = ReturnType<typeof useGetJurisdictionCodeBooksLazyQuery>;
export type GetJurisdictionCodeBooksSuspenseQueryHookResult = ReturnType<typeof useGetJurisdictionCodeBooksSuspenseQuery>;
export type GetJurisdictionCodeBooksQueryResult = Apollo.QueryResult<GetJurisdictionCodeBooksQuery, GetJurisdictionCodeBooksQueryVariables>;